<template lang="pug">
.container
  .left
    .left-content
      img.pcSpecial(src="@/assets/imgs/privilege/pc.png", alt="alt")
      span 桌面端专享
    ul
      li.left-content-item(v-for="(item, index) in desktopList"  @click="selectItem(index,0)")
        .content-wrap(:class="{isSelected: selected == index && type == 0}")
          img.left-content-item-img(v-show="selected == index && type == 0", src="@/assets/imgs/privilege/point.png", alt="alt")
          img.left-content-item-img(v-show="selected !== index || type !== 0", src="@/assets/imgs/privilege/point-gray.png", alt="alt")
          span {{item}}
    .left-content.left-content-translate
      img.pcSpecial(src="@/assets/imgs/privilege/translate.png", alt="alt").
      span 翻译记录
    ul
      li.left-content-item(v-for="(item, index) in translateList" @click="selectItem(index,1)")
        .content-wrap(:class="{isSelected: selected == index && type == 1}")
          img.left-content-item-img(v-show="selected == index && type == 1", src="@/assets/imgs/privilege/point.png", alt="alt")
          img.left-content-item-img(v-show="selected !== index || type !== 1", src="@/assets/imgs/privilege/point-gray.png", alt="alt")
          span {{item}}
    .left-content.left-content-mobile
      img.pcSpecial(src="@/assets/imgs/privilege/mobile.png", alt="alt").
      span 移动端专享
    ul
      li.left-content-item(v-for="(item, index) in mobileList" @click="selectItem(index,2)")
        .content-wrap(:class="{isSelected: selected == index && type == 2}")
          img.left-content-item-img(v-show="selected == index && type == 2", src="@/assets/imgs/privilege/point.png", alt="alt")
          img.left-content-item-img(v-show="selected !== index || type !== 2", src="@/assets/imgs/privilege/point-gray.png", alt="alt")
          span {{item}}
  .right
    privilegeClassContent

</template>

<script>
import privilegeClassContent from '@/components/privilegeClassContent.vue';

export default {
  name: 'Classify',
  components: {
    privilegeClassContent,
  },
  data() {
    return {
      desktopList: [
        '文档翻译',
        '文档上传',
        '术语库',
        '文档导出',
        'AIBox',
        '文档问答',
        '单词图谱',
        '图片翻译',
        '英文写作',
        '音频翻译',
        '同传翻译',
        '权威词典',
        '离线词典',
        '截图翻译',
        '纯净去广告',
        '会员标识',
      ],
      translateList: ['图片翻译', '同传翻译', '音频翻译'],
      mobileList: ['优质外刊', '原著精读', '简洁首页', '发音指导', '网页翻译', '听力资源'],
      selected: 0,
      type: 0,
      index: 0,
    };
  },
  methods: {
    selectItem(idx, type) {
      this.selected = idx;
      this.type = type;
      if (this.type === 0) {
        this.$router.push({ path: '/privilege', hash: `#${idx}`, query: { ...this.$route.query } });
      } else if (this.type === 1) {
        this.$router.push({ path: '/privilege', hash: `#${idx + this.desktopList.length}`, query: { ...this.$route.query } });
      } else if (this.type === 2) {
        this.$router.push({ path: '/privilege', hash: `#${idx + this.desktopList.length + this.translateList.length}`, query: { ...this.$route.query } });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.container
  display flex
  justify-content center
  padding-top 42px
  .left
    width 220px
    height 1500px
    .left-content
      width 100%
      height 60px
      display flex
      justify-content flex-start
      align-items center
      padding-left 30px
      box-sizing border-box
      font-family 'PingFang HK'
      font-style normal
      font-weight 500
      font-size 18px
      line-height 18px
      margin-bottom 3px
      margin-top 20px
      .pcSpecial
        width 26px
        height 26px
        margin-right 5px
    .left-content-mobile
      margin-top 17px
    .left-content-item
      width 196px
      height 48px
      display flex
      justify-content flex-start
      align-items center
      box-sizing border-box
      cursor pointer
      font-family 'PingFang SC'
      font-style normal
      font-weight 400
      font-size 16px
      line-height 19px
      color #626469
      .content-wrap
        width 196px
        height 44px
        display flex
        justify-content flex-start
        align-items center
        padding-left 40px
        margin-left 9px
        box-sizing border-box
        .left-content-item-img
          width 4px
          margin-right 8px
      .isSelected
        background url("~@/assets/imgs/privilege/font-back.png") 0 0 / 100% 100% no-repeat
        font-weight 500
        color #593712
  .right
    width 1004px
    margin-bottom 50px
    display block
</style>
>
